import MP4Box from 'mp4box'
export async function checkFileFormatBeforeUpload(file) {
	const isVideo = file.type === 'video/mp4' || file.type === 'video/ogg' || file.type === 'video/webm';
	// if (!isVideo) {
	//     this.$message.warning('请上传正确格式的视频！');
	//     return false
	// } 
	console.log("isVideo " +isVideo + " filetype " + file.type)
	if (isVideo) {
		// 正确的视频后缀会有mime信息
		let result = await checkVideoCode(file)
		let valid = getCodecValid(result.mime)
		if (!valid) {
			//
			return false
		}
	}
	return true
}

async function checkVideoCode(file) {
	return new Promise((resolve, reject) => {
		const mp4boxFile = MP4Box.createFile();
		const reader = new FileReader();
		reader.readAsArrayBuffer(file);
		reader.onload = function(e) {
			const arrayBuffer = e.target.result;
			arrayBuffer.fileStart = 0;
			mp4boxFile.appendBuffer(arrayBuffer);
		};
		mp4boxFile.onReady = function(info) {
			resolve(info)
		};
		mp4boxFile.onError = function(info) {
			reject(info)
		};
	})
}

function getCodecValid(str) {
	let arr = str.split(';')
	return !!(/* arr[1].includes('mp4a') || */arr[1].includes('avc1'));
}
